import OffercardCommon from './containers/offercardCommon'

export {default as OffercardCommonLayout} from './components/offercardCommonLayout'

export default OffercardCommon
